const state = {
  outUrlList: [],
};

const mutations = {
  SET_OUTURL_LIST: (state, outUrlObj) => {
    state.outUrlList.push(outUrlObj);
  },
};

const actions = {
  setOutUrlList({ commit }, outUrlObj) {
    commit('SET_OUTURL_LIST', outUrlObj);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
